import SelectModal from "./SelectModal";
import Commander from "../../commander";
import { useAppDispatch } from "../../hooks";
import { formatCurrency } from "../../utils";
// import { setStake } from "../../store/slices/selectors";
import { delayedCloseModal } from "../../store/slices/modals";
import { useAppSelector } from "../../hooks";
import { RootState } from "../../store";

const StakeSelect: React.FC<{ shown: boolean }> = (props) => {
  const dispatch = useAppDispatch();
  const { stake, currency, layout } = useAppSelector((state: RootState) => {
    return {
      layout: state.layout,
      stake: state.selectors.stake,
      currency: state.details.currency,
    };
  });

  const cols = layout.width > 500 ? 2 : 1;
  const possibleValues = (stake.possibleValues as number[]).map((a) => {
    return { value: a, text: formatCurrency(a, currency) };
  }) as any;
  const data = { value: stake.value, possibleValues };

  return (
    <SelectModal
      {...props}
      data={data}
      soundEffect="button-click"
      className="select-stake"
      cols={cols}
      flow="row"
      onSelect={(value) => {
        if (value === data.value) return;

        Commander.setStake(value);
        dispatch(delayedCloseModal("stake", 200));
      }}
    />
  );
};

export default StakeSelect;
